import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 导航
    language: "cn",
    navSign: "",
    userInfo: null,
    competitionList: null,
    competitionListModal: false,
    perfectCompanyInfoModal: false,
    showHeader: false,
		isDPICodeModal: false
  },
  getters: {
    getLanguage: state => state.language,
    getUserInfo: state => state.userInfo,
    getCompetitionList: state => state.competitionList,
		getIsDPICodeModal: state => state.isDPICodeModal
  },
  mutations: {
    setCompetitionList:(state, competitionList)=>{
      state.competitionList = competitionList;
    },
    setLanguage: (state, language)=>{
      state.language = language;
    },
    setUserInfo: (state, userInfo)=>{
      state.userInfo = userInfo;
      window.localStorage.setItem("n_userInfo", JSON.stringify(userInfo));
    },
    setCompetitionListModal: (state, competitionListModal)=>{
      state.competitionListModal = competitionListModal;
    },
    setPerfectCompanyInfoModal: (state, perfectCompanyInfoModal)=>{
      state.perfectCompanyInfoModal = perfectCompanyInfoModal;
    },
		setIsDPICodeModal: (state, isDPICodeModal)=>{
      state.isDPICodeModal = isDPICodeModal;
    }
  },
  modules: {
  }
})
